import { useEffect } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { UserEmailQuery } from "src/api/User";
import { BorderButton } from "src/components/buttons/BorderButton";
import { CartHeader } from "src/components/checkout/CartHeader";
import { Form, useForm } from "src/components/forms/Form";
import InputError from "src/components/inputs/InputError";
import { InputText } from "src/components/inputs/InputText";
import Container from "src/components/layout/Container";
import { apiClient } from "src/stores/Api";
import { useSession } from "src/stores/Session";
import { useStore } from "src/stores/Store";
import helmet from "src/utils/helmet";
import message from "src/utils/message";
import tw from "src/utils/tw";
import { useSearchParams } from "src/utils/useSearchParams";
import { Level, userEmail } from "types/code-generator";

interface Props {
  isRegister?: boolean;
}

interface FormValues {
  email: string;
}

export default function Email(props: Props) {
  const history = useHistory();
  const store = useStore();
  const session = useSession();
  const form = useForm<FormValues>();
  const params = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    helmet.setPageTitle("Email");
  }, []);

  function onSubmit() {
    form.validateFields().then((values) => onNext(values));
  }

  async function onNext(values) {
    const email = values.email.toLowerCase();
    session.updateAccountOwner({
      email,
    });

    const processingMessage = message.loading("Checking email…");

    try {
      const hasUserProfile = await apiClient<userEmail>(UserEmailQuery, {
        variables: {
          email,
        },
      });

      console.log("hasUserProfile", hasUserProfile);

      if (hasUserProfile) {
        if (session.accountOwner && hasUserProfile.userEmail.hasPhone) {
          session.accountOwner.phone = true as any;
        }

        if (props.isRegister) {
          if (!hasUserProfile.userEmail.hasPassword) {
            history.push(
              `/register/${hasUserProfile.userEmail.id}${location.search}`
            );
          } else {
            history.push("/register/password");
          }
        } else {
          history.push("/cart/password");
        }
      }
    } catch (e) {
      console.log("e", e);

      if (props.isRegister) {
        history.push(`/register/new-password${location.search}`);
      } else {
        history.push(`/cart/new-account${location.search}`);
      }
    }

    processingMessage();
  }

  function onRegisterExit() {
    history.push("/");
  }

  if (
    store.user?.id &&
    store.user.level !== Level.Captyn &&
    !props.isRegister
  ) {
    return <Redirect to="/cart/account-existing" />;
  }

  let title = "Account";
  let subtitle;

  if (props.isRegister) {
    title = "Create Your Account";
    subtitle = `Welcome to ${store.organization.title}`;
  }

  return (
    <>
      <CartHeader
        title={title}
        subtitle={subtitle}
        onExit={props.isRegister && onRegisterExit}
        isRegister={props.isRegister}
      />
      <Container large main className={tw("pb-14", "pt-28", "bg-white")}>
        <Container>
          <Form onSubmit={onSubmit}>
            <div className="pb-4 pt-4">
              <div className="mb-4">
                <div className="mb-2">
                  <strong>Email</strong>
                </div>
                <div className="">
                  {form.getFieldDecorator("email", {
                    initialValue: params.get("email") || "",
                    rules: [
                      {
                        required: true,
                        message: "Please enter your email",
                      },
                      {
                        type: "email",
                        message: "Please enter a valid email",
                      },
                    ],
                  })(
                    <InputText placeholder="email@address.com" type="email" />
                  )}
                  <InputError error={form.errors.email} className="mt-2" />
                </div>
              </div>

              <div>
                <BorderButton type="submit" className="sm:w-full">
                  Continue
                </BorderButton>
              </div>
            </div>
          </Form>
        </Container>
      </Container>
    </>
  );
}
